////////////////////////////////////////////////////////////////////////////////
//
// Store dispenser module
//
////////////////////////////////////////////////////////////////////////////////

import {Mutation} from "@/store/mutations";
import {Action} from "@/store/actions";
import ApiService from "@/services/api.service";

const state = {
    // complete dispensers objects
    dispensers: [],
    // sites dispensers like: { value: entry.name, text: entry.name }
    dispensersSelect: [],
}

////////////////////////////////////////////////////////////////////////////////

const getters = {
    dispenserByName: state => (name) => state.dispensers.find(dispenser => dispenser.name === name)
};

////////////////////////////////////////////////////////////////////////////////

const actions = {
    async [Action.dispenser.load](context) {
        try {
            const result = await ApiService.dispenser.all()
            if (Array.isArray(result.data.data.data)) {
                context.commit(Mutation.dispenser.set, result.data.data.data)
            } else {
                context.commit(Mutation.dispenser.set, [])
            }
        } catch (error) {
            context.commit(Mutation.notifyApiError, error)
            return Promise.reject(error)
        }
    },
    async [Action.dispenser.add](context, document) {
        try {
            const result = await ApiService.dispenser.add({document})
            context.commit(Mutation.notify, {message: result.data.data.status, type: 'success'})
        } catch (error) {
            context.commit(Mutation.notifyApiError, error)
            return Promise.reject(error)
        }
    },

    async [Action.dispenser.delete](context, dispenser) {
        try {
            await ApiService.dispenser.del(dispenser.name)
            await this.dispatch(Action.dispenser.load)
            context.commit(Mutation.notify, {message: "Dispenser deleted", type: 'success'})
        } catch (error) {
            context.commit(Mutation.notifyApiError, error)
            return Promise.reject(error)
        }
    },

    async [Action.dispenser.save](context, data) {
        try {
            await ApiService.dispenser.save(data.name, data.data)
            context.commit(Mutation.notify, {message: "Dispenser saved", type: 'success'})
        } catch (error) {
            context.commit(Mutation.notifyApiError, error)
            return Promise.reject(error)
        }
    },
    async [Action.dispenser.listGroupFiles](context, { groupId, siteId }) {
    try {
        const params = {
            level: 'group',
            group_id: groupId,
        };
        if (siteId) {
            params.site_id = siteId;
        }
        // Use the existing ApiService method that calls the file endpoint
        const response = await ApiService.getT('file', { params });
        return response.data;   // returns { files: [...] }
    } catch (error) {
        context.commit(Mutation.notifyApiError, error);
        return Promise.reject(error);
    }
},
    async [Action.dispenser.uploadGroupFile](context, formData) {
        try {
            const result = await ApiService.dispenser.uploadGroupFile(formData);
            return result;
        } catch (error) {
 if (error.response?.data?.message?.includes('device_path')) {
        context.commit(Mutation.setError, 'Invalid device path format');
      } else {
        context.commit(Mutation.notifyApiError, error);
      }            return Promise.reject(error);
        }
    },
     async [Action.dispenser.uploadGroupFirmware](context, formData) {
    try {
      const result = await ApiService.dispenser.uploadGroupFirmware(formData);
      return result;
    } catch (error) {
      context.commit(Mutation.notifyApiError, error);
      return Promise.reject(error);
    }
  },
async [Action.dispenser.listGroupFirmware](context, { groupId, siteId, include_entity = false }) {
    try {
        const response = await ApiService.dispenser.listGroupFirmware(
            groupId,
            siteId,          // site_id
            'CC2',            // deviceType
            include_entity    // ← this will now be passed
        );
        return response.data;
    } catch (error) {
        context.commit(Mutation.notifyApiError, error);
        return Promise.reject(error);
    }
},
    
    async [Action.dispenser.deleteGroupFile](context, fileId) {
        try {
            const response = await ApiService.dispenser.deleteGroupFile(fileId);
            return response.data;
        } catch (error) {
            context.commit(Mutation.notifyApiError, error);
            return Promise.reject(error);
        }
    },
     async [Action.dispenser.listGroupFirmware](context, { groupId, siteId, include_entity = false }) {
    try {
        const response = await ApiService.dispenser.listGroupFirmware(
            groupId, 
            siteId,           // site_id
            'CC2',            // deviceType
            include_entity    // ← pass the flag
        );
        return response.data;
    } catch (error) {
        context.commit(Mutation.notifyApiError, error);
        return Promise.reject(error);
    }
},
  
  async [Action.dispenser.deleteGroupFirmware](context, firmwareId) {
    try {
      const response = await ApiService.dispenser.deleteGroupFirmware(firmwareId);
      return response.data;
    } catch (error) {
      context.commit(Mutation.notifyApiError, error);
      return Promise.reject(error);
    }
  },
  // Add these to your store actions
async [Action.dispenser.deleteAllGroupFiles](context, groupId) {
  try {
    const response = await ApiService.dispenser.deleteAllGroupFiles(groupId);
    return response.data;
  } catch (error) {
    context.commit(Mutation.notifyApiError, error);
    return Promise.reject(error);
  }
},

async [Action.dispenser.deleteAllGroupFirmware](context, { groupId, deviceType }) {
  try {
    const response = await ApiService.dispenser.deleteAllGroupFirmware(groupId, deviceType);
    return response.data;
  } catch (error) {
    context.commit(Mutation.notifyApiError, error);
    return Promise.reject(error);
  }
}
,
async [Action.dispenser.uploadGroupIcon](context, formData) {
        try {
           //console.log("Uploading icon via store module");
            const response = await ApiService.dispenser.uploadGroupIcon(formData);
            return response.data;
        } catch (error) {
            context.commit(Mutation.notifyApiError, error);
            return Promise.reject(error);
        }
    },
    
    async [Action.dispenser.listGroupIcons](context, { groupId, siteId }) {
  try {
   //console.log("=== LIST GROUP ICONS DEBUG ===");
   //console.log("Parameters:", { groupId, siteId });
    
    const response = await ApiService.dispenser.listGroupIcons(groupId, siteId);
    
   //console.log("Raw axios response:", response);
   //console.log("Response status:", response.status);
   //console.log("Response headers:", response.headers);
   //console.log("Response.data:", response.data);
   //console.log("Response.data type:", typeof response.data);
   //console.log("=== END DEBUG ===");
    
    // Try different structures
    if (Array.isArray(response.data)) {
      // Direct array
      return response.data;
    } else if (response.data && response.data.icons) {
      // Wrapped in icons property
      return response.data.icons;
    } else if (Array.isArray(response)) {
      // Response itself is array (unlikely)
      return response;
    } else {
      console.warn("Unexpected response structure:", response);
      return [];
    }
    
  } catch (error) {
    console.error("Error listing icons:", error);
    console.error("Error response:", error.response?.data);
    context.commit(Mutation.notifyApiError, error);
    return Promise.reject(error);
  }
},
    
    async [Action.dispenser.deleteGroupIcon](context, iconId) {
        try {
            const response = await ApiService.dispenser.deleteGroupIcon(iconId);
            return response.data;
        } catch (error) {
            context.commit(Mutation.notifyApiError, error);
            return Promise.reject(error);
        }
    },
    
    async [Action.dispenser.deleteAllGroupIcons](context, groupId) {
        try {
            const response = await ApiService.dispenser.deleteAllGroupIcons(groupId);
            return response.data;
        } catch (error) {
            context.commit(Mutation.notifyApiError, error);
            return Promise.reject(error);
        }
    }

}


////////////////////////////////////////////////////////////////////////////////

const mutations = {
    [Mutation.dispenser.set](state, dispensers) {
        state.dispensers = dispensers;
        state.dispensersSelect = [{value: null, text: '-'}]
        dispensers.forEach((entry) => {
            state.dispensersSelect.push({ value: entry.name, text: entry.name })
        })
    }
}

////////////////////////////////////////////////////////////////////////////////

const dispenser = {
    state: state,
    getters: getters,
    actions: actions,
    mutations: mutations,
}
export default dispenser